export default __webpack_public_path__ + "static/media/Close.26fe3f8c.svg";